/*arguments*/
/*status*/
/*enable*/
/*disable*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "telemetry",
  "description": "`turbo telemetry` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "管理此机器的遥测数据。"
  }, {
    "heading": "",
    "content": "¥Manage telemetry for this machine."
  }, {
    "heading": "",
    "content": "了解有关 Turborepo 遥测的更多信息。"
  }, {
    "heading": "",
    "content": "¥Learn more about Turborepo's telemetry."
  }, {
    "heading": "参数-arguments",
    "content": "¥Arguments"
  }, {
    "heading": "status-status",
    "content": "检索此计算机的当前遥测状态。"
  }, {
    "heading": "status-status",
    "content": "¥Retrieve the current state of telemetry for this machine."
  }, {
    "heading": "enable-enable",
    "content": "为此机器启用遥测。"
  }, {
    "heading": "enable-enable",
    "content": "¥Enable telemetry for this machine."
  }, {
    "heading": "disable-disable",
    "content": "禁用此计算机的遥测。"
  }, {
    "heading": "disable-disable",
    "content": "¥Disable telemetry for this machine."
  }],
  "headings": [{
    "id": "参数-arguments",
    "content": "参数 /*arguments*/"
  }, {
    "id": "status-status",
    "content": "status /*status*/"
  }, {
    "id": "enable-enable",
    "content": "enable /*enable*/"
  }, {
    "id": "disable-disable",
    "content": "disable /*disable*/"
  }]
};
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#参数-arguments",
  title: _jsx(_Fragment, {
    children: "参数 "
  })
}, {
  depth: 3,
  url: "#status-status",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "status"
    }), " "]
  })
}, {
  depth: 3,
  url: "#enable-enable",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "enable"
    }), " "]
  })
}, {
  depth: 3,
  url: "#disable-disable",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "disable"
    }), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [argument]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "管理此机器的遥测数据。"
    }), "\n", _jsx(_components.p, {
      children: "¥Manage telemetry for this machine."
    }), "\n", _jsxs(LinkToDocumentation, {
      href: "/docs/telemetry",
      children: [_jsx(_components.p, {
        children: "了解有关 Turborepo 遥测的更多信息。"
      }), _jsx(_components.p, {
        children: "¥Learn more about Turborepo's telemetry."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "参数-arguments",
      children: "参数 "
    }), "\n", _jsx(_components.p, {
      children: "¥Arguments"
    }), "\n", _jsxs(_components.h3, {
      id: "status-status",
      children: [_jsx(_components.code, {
        children: "status"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "检索此计算机的当前遥测状态。"
    }), "\n", _jsx(_components.p, {
      children: "¥Retrieve the current state of telemetry for this machine."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " status"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "enable-enable",
      children: [_jsx(_components.code, {
        children: "enable"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "为此机器启用遥测。"
    }), "\n", _jsx(_components.p, {
      children: "¥Enable telemetry for this machine."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " enable"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "disable-disable",
      children: [_jsx(_components.code, {
        children: "disable"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "禁用此计算机的遥测。"
    }), "\n", _jsx(_components.p, {
      children: "¥Disable telemetry for this machine."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " disable"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
